import { render, staticRenderFns } from "./KitDialogSelect.vue?vue&type=template&id=48585954&scoped=true"
import script from "./KitDialogSelect.vue?vue&type=script&lang=ts"
export * from "./KitDialogSelect.vue?vue&type=script&lang=ts"
import style0 from "./KitDialogSelect.vue?vue&type=style&index=0&id=48585954&prod&lang=scss"
import style1 from "./KitDialogSelect.vue?vue&type=style&index=1&id=48585954&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48585954",
  null
  
)

export default component.exports